import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SiteHeader } from 'src/components/ui/SiteHeader';
import { Routes, Routes as RoutesData } from 'src/router/Routes';
import AddIcon from '@mui/icons-material/Add';
import { Button, Card, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import PaidIcon from '@mui/icons-material/Paid';
import { RevenuePoolsTable } from './RevenuePoolsTable';
import { useNavigate } from 'react-router-dom';

export const RevenuePoolsOverview: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <SiteHeader
        breadcrumbs={[
          {
            link: RoutesData.REVENUE_POOLS.ROOT,
            label: t('revenuePools.overview.routeLabel'),
            icon: <PaidIcon sx={{ mr: 0.5 }} fontSize="inherit" />,
          },
        ]}
        headline={t('revenuePools.overview.title')}
      >
        <Button
          variant="contained"
          disableElevation
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => navigate(Routes.REVENUE_POOLS.ADD)}
        >
          {t('revenuePools.overview.addNew')}
        </Button>
      </SiteHeader>
      <Card sx={{ p: 2 }}>
        <Grid container>
          <Grid flexGrow={1}>
            <Typography variant="h5" sx={{ fontWeight: 500, mb: 3 }}>
              {t('revenuePools.overview.table.title')}
            </Typography>
          </Grid>
        </Grid>
        <RevenuePoolsTable />
      </Card>
    </>
  );
};
